export default __webpack_public_path__ + "static/media/manual-de-boas-praticas-mario-ito.afbb5c91.pdf";